import { render, staticRenderFns } from "./ModalExtendMarketplaceToken.vue?vue&type=template&id=09ec733c&"
import script from "./ModalExtendMarketplaceToken.vue?vue&type=script&lang=js&"
export * from "./ModalExtendMarketplaceToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports